import type { ApiResponse } from '../../../../config/api-types'
import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { GetCollectionOrderStatusRequest } from '../../domain/models/get-collection-order-status'
import type { IGetCollectionOrderStatus } from '../../domain/use-cases/i-get-collection-order-status'
import type { IGetCollectionOrderStatusClient } from '../data-sources/i-get-collection-order-status-client'

export class GetCollectionOrderStatusRepository implements IGetCollectionOrderStatus {
  constructor(private readonly dataSource: IGetCollectionOrderStatusClient) {}

  async getStatus(param: GetCollectionOrderStatusRequest): Promise<ApiResponse> {
    const result = await this.dataSource.getStatus(param)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result.message!)
    }

    return result.data
  }
}